import Image from "next/image";

import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface AppItemSectionProps {
  image: string;
  label: string;
}

const AppItemSection: FC<AppItemSectionProps> = ({ image, label }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box sx={{ maxWidth: { xs: 40, md: 80, lg: 100 } }}>
        <Image
          src={image}
          width={100}
          height={100}
          alt=""
          style={{
            width: "100%",
            objectFit: "contain",
            height: "auto",
          }}
        />
      </Box>
      <Typography paragraph sx={{ mb: 0 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default AppItemSection;
